module.exports = __webpack_public_path__ + "img/23_41.5c7e0eb2.png";